import api from '../../services/api';

export enum GroupActionTypes {
  FETCH_USER_GROUPS = 'FETCH_USER_GROUPS'
}

export function fetchUserGroups(userId: string) {
  return function (dispatch) {
    return api.get(`/groups/userGroups/${userId}`).then(({ data }) => {
      dispatch({
        type: GroupActionTypes.FETCH_USER_GROUPS,
        payload: data
      });
    });
  };
}

export const getUserGroups = (state) => state.groups.groups;
